import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function ClauzeStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <SelectField
        label="Termen de preaviz pentru reziliere"
        value={data.preavizReziliere}
        onChange={update("preavizReziliere")}
        options={[
          { value: "15", label: "15 zile" },
          { value: "30", label: "30 zile" },
          { value: "60", label: "60 zile" },
        ]}
        half
      />

      <div style={{ width: "100%" }}>
        <Toggle
          label="Include clauza de confidentialitate (NDA)"
          description="Partile se obliga sa pastreze confidentialitatea informatiilor"
          checked={!!data.includeNDA}
          onChange={() => update("includeNDA")(!data.includeNDA)}
        />
      </div>

      <div style={{ width: "100%" }}>
        <Toggle
          label="Include clauza de non-concurenta"
          description="Prestatorul se obliga sa nu presteze servicii similare pentru concurentii beneficiarului"
          checked={!!data.includeNonCompete}
          onChange={() => update("includeNonCompete")(!data.includeNonCompete)}
        />
      </div>

      <div style={{ width: "100%" }}>
        <Toggle
          label="Drepturile de proprietate intelectuala se transfera beneficiarului"
          description="Daca nu este activat, drepturile raman la prestator"
          checked={!!data.transferPI}
          onChange={() => update("transferPI")(!data.transferPI)}
        />
      </div>

      <SelectField
        label="Instanta competenta"
        value={data.instantaCompetenta}
        onChange={update("instantaCompetenta")}
        options={[
          { value: "domiciliu_prestator", label: "Instanta de la domiciliul/sediul prestatorului" },
          { value: "domiciliu_beneficiar", label: "Instanta de la domiciliul/sediul beneficiarului" },
          { value: "executare", label: "Instanta de la locul executarii contractului" },
        ]}
      />
    </div>
  );
}
